import React from "react";
import "./_compare-insertion-tooltip.scss";
import DesktopCalendarTaskDrawerFileItem from "../calendar/drawer/file-list/DesktopCalendarTaskDrawerFileItem";
import {getFarmID} from "../../selectors/farmSelector";
import {useSelector} from "react-redux";
import {utcDateFormatter} from "../../utils/DateTimeUtils";
import {formatLocationName} from "../../utils/global-formatters/formatLocationName";
import Highlight from "../basics/highlight/Highlight";
import {isEqual} from "lodash";

export default function CompareWeightsTooltip({
    label,
    payload,
    data,
    isXAxisEqual = isEqual,
}) {
    // #12171 - display multiple values that share the same X coordinate
    const events = data
        ? data.filter((e) => isXAxisEqual(e.time, label))
        : payload;
    const FarmID = useSelector(getFarmID);

    return (
        <div className="compare-insertion-tooltip recharts-default-tooltip">
            <div>{utcDateFormatter(label)}</div>
            <ul>
                {!!events &&
                    events.map((item, i) => {
                        return i !== 0 &&
                            item.dataKey === "estimated" ? null : (
                            <li key={i} style={{color: item.fill}}>
                                <span>
                                    {item.dataKey === "estimated" ? (
                                        <>
                                            {item.name}:{" "}
                                            {item.formatter
                                                ? item.formatter(item.value)
                                                : item.value}
                                            {item.unit}
                                        </>
                                    ) : (
                                        <>
                                            {formatLocationName(
                                                item.payload.PlcmntID
                                            )}
                                            :{" "}
                                            {item.formatter
                                                ? item.formatter(item.value)
                                                : item.value}
                                            {item.unit}
                                        </>
                                    )}
                                    {!!item.payload.AnmCnt &&
                                        item.dataKey !== "estimated" && (
                                            <small className={"ms-2"}>
                                                <Highlight>
                                                    <i
                                                        className={
                                                            "fas fa-fw fa-pig"
                                                        }
                                                    />{" "}
                                                    {item?.payload?.[
                                                        `${item.dataKey}_AnmCnt`
                                                    ] || item.payload.AnmCnt}
                                                </Highlight>
                                            </small>
                                        )}
                                </span>
                                {(item.payload.Files || []).map((file) => (
                                    <DesktopCalendarTaskDrawerFileItem
                                        file={file}
                                        FarmID={FarmID}
                                    />
                                ))}
                            </li>
                        );
                    })}
            </ul>
        </div>
    );
}
